import {createRouter, createWebHistory} from 'vue-router'
import ContactView from '../views/ContactView.vue'
import BookingDetails from "../views/BookingDetails.vue";
import SuccessView from "@/views/SuccessView.vue";
import ForbiddenView from "@/views/ForbiddenView.vue";
import PaymentView from "@/views/PaymentView.vue";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'bookingDetails',
            component: BookingDetails
        },
        {
            path: '/contact',
            name: 'contact',
            component: ContactView
        },
        {
            path: '/success',
            name: 'success',
            component: SuccessView
        },
        {
            path: '/payment',
            name: 'payment',
            component: PaymentView
        },
        {
            path: '/forbidden',
            name: 'forbidden',
            component: ForbiddenView
        }
    ]
})

export default router
